import { useQuery } from "@apollo/client";

import { GET_USER_DETAILS } from "./gql";

type UseGetUserProps = {
  id?: string;
};

const useGetUser = ({ id }: UseGetUserProps) => {
  const { data, loading, error } = useQuery(GET_USER_DETAILS, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  return { user: data?.managedUser, loading, error };
};

export default useGetUser;
